import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { OperationInterface } from '../data';
import { OperationProvider } from '../providers/operation.provider';
import { Transaction } from '../transaction/transaction';
import { UseCase } from './common/use.case';

@Injectable()
export class GetOperationUseCase implements UseCase<Observable<Transaction<OperationInterface>>> {
    constructor(private operationProvider: OperationProvider) {}

    bind(): Observable<Transaction<OperationInterface>> {
        return this.operationProvider.find().pipe(
            map((transaction) =>
                transaction.map(
                    (operation) => Transaction.success(cloneDeep(operation)),
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
